<div class="bootcamp-section">
  <div class="bootcamp-content">
    <div class="bootcamp-text">
      <h1>
        <span class="highlight">11+ BRIDGE COURSES </span><br />
       <span class="highlight">Year 4 To Year 5 </span><br />
      </h1>
      <div class="subtitle">
        BRIDGE THE GAP FROM YEAR 4 TO YEAR 5 WITH CONFIDENCE!
        
      </div>
    </div>
    <div class="bootcamp-img">
      <img src="assets/images/bridge-img.png" alt="Summer Bootcamp Girl">
    </div>
  </div>
</div>

<div class="trending-section">
  <div class="section-title">Trending</div>
  <div class="courses-grid">
    <div class="course-card" *ngFor="let course of bootcampCourses">
      <div class="course-image">
        <img [src]="course.image" alt="{{course.highlight}}">
      </div>
      <div class="course-info">
        <div class="course-title">
          {{ course.title }}<br>
          <span class="highlight">{{ course.highlight }}</span>
        </div>
        <ul class="feature">
          <li *ngFor="let feature of course.features">🌟 {{feature}}</li>
        </ul>
        <div class="price-row">
          <span class="price-label">Price:</span>
          <span class="price-value">{{course.price}}<span class="price-suffix">/-</span></span>
        </div>
        <div class="course-actions">
          <a [href] = "course.bookLink" class="book-btn">Book Now</a>
          <a [href] = "course.detailsLink" class="details-btn">View Details</a>
        </div>
      </div>
    </div>
  </div>
</div>